/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : dashboard.js
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
/**
 * @author : Narender - narender@au79consulting.com
 * @Date : 01-09-2024
 * @description Dashboard API details to perform a particular action
*/
import actionType from "../actionTypes";

const dashboardAction = {
    // Get tickets status
    get_tickets_status: {
        api_name: "/PCM/dashboard/tickets/status",
        https_method: "GET",
        action_type: actionType.GET_TICKETS_STATUS,
        description: "",
    },
    get_dash_board_status: {
        api_name: "/PCM/dashboard/status",
        https_method: "GET",
        action_type: actionType.GET_DASH_BOARD_STATUS,
        description: ""
    },
    get_dash_board_activities: {
        api_name: "/PCM/dashboard/recent_activities",
        https_method: "GET",
        action_type: actionType.GET_DASH_BOARD_ACTIVITY,
        description: ""
    },
    get_tickets: {
        api_name: "/ACM/intersections/tickets",
        https_method: "GET",
        action_type: actionType.GET_TICKETS,
        description: "Get Tickets",
    },
}
export default dashboardAction;